import { ItemPlusMore } from '~/components/ItemPlusMore/ItemPlusMore';
import type { ArtistType } from '~/modules/artist-roster/types';

interface LabelsCellProps {
  artist: ArtistType;
}

export function LabelsCell({ artist }: LabelsCellProps) {
  return <ItemPlusMore items={artist.labels} itemNameKey="name" />;
}

LabelsCell.displayName = 'LabelsCell';
